var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contentComposition)?_c('div',[(_vm.isComposition)?_c('iframe',{staticClass:"element-position",class:_vm.className,style:(_vm.style),attrs:{"scrolling":"no","src":_vm.compositionUrl}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }